module.exports = __webpack_public_path__ + "img/GrayOutline300.e66f9d5c.png";